import {
  Component,
  computed,
  inject,
  input,
  ChangeDetectionStrategy
} from '@angular/core';
import { NotificationDto } from '@bannerflow/types.notification-service';
import {
  UITooltipDirective,
  UISVGIconComponent,
  UINUIIcon
} from '@bannerflow/ui';
import { NotificationService } from '../../../../services/notification.service';

@Component({
  selector: 'ns-read-status-marker',
  imports: [UITooltipDirective, UISVGIconComponent],
  templateUrl: './read-status-marker.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './read-status-marker.component.scss'
})
export class ReadStatusMarkerComponent {
  private notificationService = inject(NotificationService);

  notification = input.required<NotificationDto>();

  statusIcon = computed(() => this.computeStatusIcon());

  markAsRead(event: Event): void {
    event.stopPropagation();
    const notification = this.notification();
    this.notificationService.markAsRead(notification);
  }

  private computeStatusIcon(): UINUIIcon {
    const notification = this.notification();
    switch (notification.type) {
      case 'success':
        return 'status-approved-colored';
      case 'error':
        return 'status-not-approved-colored';
      case 'information':
        return 'status-for-review-colored';
      default:
        return 'status-for-review-colored';
    }
  }
}
